export const UNPAID_ADJUSTMENT_JOB_STATUSES = [
  'canceled_with_fee',
  'no_show',
  'late_cancellation',
  'missed_shift',
];
